import React from 'react';

import { Separator } from '../shadcn/separator';

import { Skeleton } from '@/shared/components/shadcn/skeleton';
import { cn } from '@/shared/utils/cn';

interface TableSkeletonProps {
  columns: {
    className: string;
  }[];
  rows: number;
  header?: boolean;
  headerHeight?: string;
  rowHeight?: string;
  className?: string;
}

export function TableSkeleton({
  columns,
  rows,
  rowHeight = 'h-20',
  header = true,
  headerHeight = 'h-12',
  className,
}: TableSkeletonProps) {
  return (
    <div className={cn('w-full', className)} data-testid="table-skeleton">
      {header ? (
        <>
          <div className={cn('flex w-full items-center gap-2', headerHeight)}>
            {columns.map((column, colIndex) => (
              <Skeleton key={colIndex} className={`h-4 ${column.className}`} />
            ))}
          </div>
          <Separator />
        </>
      ) : null}

      <div className="flex flex-col">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <React.Fragment key={rowIndex}>
            <div className={cn('flex w-full items-center gap-2', rowHeight)}>
              {columns.map((column, index) => (
                <Skeleton key={index} className={`h-4 ${column.className}`} />
              ))}
            </div>
            {rowIndex !== rows - 1 && <Separator />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
